import React from 'react';
import { connect } from 'react-redux';
import Component from "./Component";
import { ProgramProvider } from "../../../Providers";
import { getApplication } from "../../../../../store/Selectors";
var Content = function Content(props) {
  var application = props.application,
    onExit = props.onExit;
  return /*#__PURE__*/React.createElement(ProgramProvider, null, /*#__PURE__*/React.createElement(Component, {
    onExit: onExit,
    application: application
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var application = getApplication(state);
  return {
    application: application
  };
};
var connector = connect(mapStateToProps);
export default connect(mapStateToProps)(Content);